import { ToneDto } from '../tonedto';

export interface GetKaroakeListDto
{
    getClientTxnId(): string;
    getChannelId(): string;
    getServiceId(): string;
    getAPartyMsisdn(): string;
    getLanguage(): string;

    getListOfTones(): ToneDto[];
}

export class GetKaroakeListDtoImpl implements GetKaroakeListDto
{
    private clientTxnId: string;
    private channelId: string;
    private serviceId: string;
    private aPartyMsisdn: string;
    private language: string;
    private karoakeList: ToneDto[];

    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }
    getClientTxnId(): string 
    {
        return this.clientTxnId;
    } 

    setServiceId(serviceId: string)
    {
        this.serviceId = serviceId;
    }
    getServiceId(): string 
    {
        return this.serviceId;
    } 

    setAPartyMsisdn(aPartyMsisdn: string)
    {
        this.aPartyMsisdn = aPartyMsisdn;
    }
    getAPartyMsisdn(): string 
    {
        return this.aPartyMsisdn;
    } 

    setChannelId(channelId: string)
    {
        this.channelId = channelId;
    }
    getChannelId(): string 
    {
        return this.channelId;
    } 

    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }

    getListOfTones(): ToneDto[]
    {
        return this.karoakeList;
    }
    setListOfTones(karoakeList: ToneDto[])
    {
        this.karoakeList = karoakeList;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/getkaroakelist/getkaroakelistdto.ts